export function companyPortfolio() {
    let $holderPortfolio = $('.holder-company-portfolio');
    let $holderInfoGallery = $('.ajax-holder-info-gallery');
    let $sections = $('.section');

    function loadInfoGallery() {
        $holderPortfolio.on('click', 'a.btn-load-info-gallery', function (e) {
            e.preventDefault();

            let data = {
                'action': 'load_info_gallery',
                'data': $(this).attr('data-gallery')
            };

            $.ajax({
                type: "POST",
                url: ajaxvars.ajaxurl,
                data: data,
                beforeSend: function () {
                },
                success: function (response) {
                    if (response.content) {
                        $sections.hide();

                        let content = $(response.content);
                        content.css({'opacity': 0});
                        $holderInfoGallery.append(content);
                        content.animate({'opacity': 1}, 300);

                        $("html, body").animate({scrollTop: $holderInfoGallery.offset().top - $('.header').innerHeight() * 1.5}, 500);
                    }
                },
                complete: function () {
                }
            });
        });
    }

    function closeInfoGallery() {
        $holderInfoGallery.on('click', 'a.back-link', function (e) {
            e.preventDefault();

            $holderInfoGallery.empty();
            $sections.show();
        });
    }

    function loadMoreGalleryImages() {
        $holderPortfolio.on('click', '.load-more-gallery-images', function (e) {
            e.preventDefault();

            let _this = $(this);
            let $parent = _this.closest('.mosaic-gallery');
            let $container = $parent.find('.holder-mosaic-gallery');
            let paged = _this.attr('data-paged');
            let max_paged = _this.attr('data-max-paged');

            paged++;

            let data = {
                'action': 'load_gallery_images',
                'data': $container.attr('data-gallery-pages'),
                'paged': paged
            };

            $.ajax({
                type: "POST",
                url: ajaxvars.ajaxurl,
                data: data,
                beforeSend: function () {
                    _this.text('Loading...').attr('disabled', true);
                },
                success: function (response) {
                    if (response) {
                        let content = $(response);
                        content.css({'opacity': 0});
                        $container.append(content);
                        content.animate({'opacity': 1}, 300);

                        _this.attr('data-paged', paged);

                        if (parseInt(max_paged) === paged) {
                            $parent.find('.button-holder').hide();
                        }
                    }
                },
                complete: function () {
                    _this.text('Load More').attr('disabled', false);
                }
            });
        });
    }

    function showMoreGallery() {
        let btn_show_more = $('a.show-more-gallery');
        if (btn_show_more.length) {
            btn_show_more.on('click', function (e) {
                e.preventDefault();

                let _this = $(this);
                let $parent = _this.closest('.portfolio');
                let $container = $parent.find('.holder-company-gallery');
                let paged = _this.attr('data-paged');
                let max_paged = _this.attr('data-max-paged');

                paged++;

                let data = {
                    'action': 'show_gallery',
                    'data': $container.attr('data-gallery-pages'),
                    'paged': paged
                };

                $.ajax({
                    type: "POST",
                    url: ajaxvars.ajaxurl,
                    data: data,
                    beforeSend: function () {
                        _this.text('Loading...').attr('disabled', true);
                    },
                    success: function (response) {
                        if (response) {
                            let content = $(response);
                            content.css({'opacity': 0});
                            $container.append(content);
                            content.animate({'opacity': 1}, 300);

                            _this.attr('data-paged', paged);

                            if (parseInt(max_paged) === paged) {
                                $parent.find('.button-holder').hide();
                            }
                        }
                    },
                    complete: function () {
                        _this.text('Show More').attr('disabled', false);
                    }
                });
            });
        }
    }

    showMoreGallery();
    loadMoreGalleryImages();
    loadInfoGallery();
    closeInfoGallery();
}


// WEBPACK FOOTER //
// ./assets/js/modules/companyPortfolio.js